import { z } from 'zod'

export const CarManufacturerZod = z.object({
  name: z.string(),
  models: z.record(
    z.string(),
    z.object({
      seats: z.number().nullable(),
    })
  ),
})
